import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import logo from "../Assets/logo.svg";
import { Menu, MenuItem } from "@mui/material";
const Navbar = ({ homeRef, servicesRef, productsRef, clientsRef, vacanciesCount, teamRef, footerRef }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery('(min-width:600px) and (max-width:1024px)');
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleScrollSpy = () => {
      const sections = [
        { ref: homeRef, name: "Home" },
        { ref: servicesRef, name: "Services" },
        { ref: productsRef, name: "Products" },
        { ref: clientsRef, name: "Partners" },
        { ref: teamRef, name: "Our team" },
        { ref: footerRef, name: "Contact" },
      ];

      let current = "Home"; // default
      const scrollPos = window.scrollY + 100; // offset for navbar height

      sections.forEach(({ ref, name }) => {
        const section = ref?.current;
        if (section) {
          const offsetTop = section.offsetTop;
          const offsetBottom = offsetTop + section.offsetHeight;
          if (scrollPos >= offsetTop && scrollPos < offsetBottom) {
            current = name;
          }
        }
      });

      setActiveLink(current);
    };

    window.addEventListener("scroll", handleScrollSpy);
    return () => window.removeEventListener("scroll", handleScrollSpy);
  }, [homeRef, servicesRef, productsRef, clientsRef, teamRef, footerRef]);


  const handleScrollToSection = (sectionRef, linkName) => {
    setMenuOpen(false);
    setTimeout(() => {
      if (location.pathname !== "/") {
        navigate("/", { state: { scrollTo: linkName } });
      } else if (sectionRef?.current) {
        sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300);
  };

  return (
    <AppBar
      ref={navbarRef}
      position="sticky"
      style={{
        padding: "10px",
        paddingLeft: "10px",
        paddingRight: "10px",
        boxShadow: "none",
        top: 0,
        zIndex: 1000,
        background: "#FFFFFF",
        borderBottom: "1px solid #E5E5E5",
      }}
    >
      <AppBarContainer>
        <ToolbarStyled>
          <LogoBox onClick={() => handleScrollToSection(homeRef, "Home")}>
            <img src={logo} alt="Logo" />
            <LogoText className="logo-font">AWURA</LogoText>
          </LogoBox>

          {!isMobile && !isTablet && (
            <>
              <NavLinks>
                <StyledLink
                  onClick={() => handleScrollToSection(homeRef, "Home")}
                  className={activeLink === "Home" ? "active" : ""}
                >
                  Home
                </StyledLink>
                <StyledLink
                  onClick={() => handleScrollToSection(servicesRef, "Services")}
                  className={activeLink === "Services" ? "active" : ""}
                >
                  Services
                </StyledLink>
                <StyledLink
                  onClick={() => handleScrollToSection(productsRef, "Products")}
                  className={activeLink === "Products" ? "active" : ""}
                >
                  Products
                </StyledLink>
                <StyledLink
                  onClick={() => handleScrollToSection(teamRef, "Our team")}
                  className={activeLink === "Our team" ? "active" : ""}
                >
                  Our team
                </StyledLink>
                <StyledLink
                  onClick={() => handleScrollToSection(clientsRef, "Partners")}
                  className={activeLink === "Partners" ? "active" : ""}
                >
                  Partners
                </StyledLink>
                <StyledNavLink
                  to="https://erp.awura.tech/jobs"
                  onClick={() => {
                    setActiveLink("Vacancy")
                  }
                  }
                  className={activeLink === "Vacancy" ? "active" : ""}
                >
                  Vacancy
                  {vacanciesCount > 0 && (
                    <Box
                      sx={{
                        display: "inline-block",
                        background: "#5F82D0",
                        color: "#FFF",
                        borderRadius: "4px",
                        padding: "2px 6px",
                        fontSize: "12px",
                        marginLeft: "8px",
                        position: "relative",
                        top: "-2px",
                      }}
                    >
                      New
                    </Box>
                  )}
                </StyledNavLink>
              </NavLinks>

              <ContactButton hideOnTablet>
                <Button
                  variant="contained"
                  onClick={() => handleScrollToSection(footerRef, "Contact")}
                  sx={{
                    backgroundColor: "#17273F",
                    ":hover": {
                      backgroundColor: "#1A202C",
                    },
                    color: "#FFFFFF",
                    borderRadius: "6px",
                    padding: "6px 24px",
                    height: "50px",
                    fontSize: "17px",
                    fontWeight: "400",
                    textTransform: "none",
                  }}
                >
                  Contact US
                </Button>
              </ContactButton>
            </>
          )}

          {(isMobile || isTablet) && (
            <TabletMobileControls>
              {isTablet && (
                <ContactButton>
                  <Button
                    variant="contained"
                    onClick={() => handleScrollToSection(footerRef, "Contact")}
                    sx={{
                      backgroundColor: "#17273F",
                      color: "#FFFFFF",
                      borderRadius: "6px",
                      padding: "6px 16px",
                      height: "40px",
                      fontSize: "14px",
                      fontWeight: "400",
                      textTransform: "none",
                      marginRight: "10px",
                    }}
                  >
                    Contact US
                  </Button>
                </ContactButton>
              )}
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={(e) => { setMenuOpen(true); setAnchorEl(e.currentTarget); }}
                sx={{ color: "#2E539C" }}
              >
                <MenuIcon />
              </IconButton>

              {/* Dropdown Menu */}
              <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                keepMounted
                slotProps={{ paper: { sx: { px: 2 } } }}

              >
                <MenuItem onClick={() => { handleScrollToSection(homeRef, "Home"); }}>Home</MenuItem>
                <MenuItem onClick={() => { handleScrollToSection(servicesRef, "Services"); }}>Services</MenuItem>
                <MenuItem onClick={() => { handleScrollToSection(productsRef, "Products"); }}>Products</MenuItem>
                <MenuItem onClick={() => { handleScrollToSection(teamRef, "Our team"); }}>Our team</MenuItem>
                <MenuItem onClick={() => { handleScrollToSection(clientsRef, "Partners"); }}>Partners</MenuItem>
                <MenuItem onClick={() => window.open("https://erp.awura.tech/jobs", "_blank")}>
                  Vacancy
                  {vacanciesCount > 0 && (
                    <Box
                      sx={{
                        background: "#5F82D0",
                        color: "#FFF",
                        borderRadius: "4px",
                        padding: "2px 6px",
                        fontSize: "12px",
                        marginLeft: "8px",
                      }}
                    >
                      New
                    </Box>
                  )}
                </MenuItem>
                {isMobile && (
                  <MenuItem onClick={() => handleScrollToSection(footerRef, "Contact")}>Contact US</MenuItem>
                )}
              </Menu>
            </TabletMobileControls>
          )}
        </ToolbarStyled>
      </AppBarContainer>
    </AppBar>
  );
};

const AppBarContainer = styled.div`
  position: relative;
  height: 70px;
  background: transparent;
  @media (max-width: 768px) {
    height: 60px;
  }
`;

const ToolbarStyled = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
  background: transparent;
  min-height: 70px !important;
  padding: 0 40px;
  @media (max-width: 768px) {
    min-height: 60px !important;
    padding: 0 16px;
  }
`;

const LogoBox = styled(Box)`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    height: 60px;
  }

  @media (max-width: 768px) {
    img {
      height: 35px;
    }
  }
`;

export const LogoText = styled.span`
  font-size: 36px;
  font-weight: 400;
  color: #2E539C;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;

  a {
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #17273F;
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

const ContactButton = styled.div`
  @media (max-width: 1024px) {
    display: ${props => props.hideOnTablet ? 'none' : 'block'};
  }
`;

const TabletMobileControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledLink = styled.a`
  color: #333333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #333333;
  }

  &.active {
    color: #333333;
    font-weight: 800;
    text-decoration: underline;
  }
`;
const StyledNavLink = styled(NavLink)`
  color: #333333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: #333333;
  }

  &.active {
    color: #333333;
    font-weight: 800;
    text-decoration: underline;
  }
`;

export default Navbar;